import { render, staticRenderFns } from "./CatalogModal.vue?vue&type=template&id=6f1e0ec0&"
import script from "./CatalogModal.vue?vue&type=script&lang=js&"
export * from "./CatalogModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports